import { useMemo, useCallback } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { Input, Label } from 'reactstrap'

import { selectDailyReportsStatus } from 'slices/dailyReportsSlice'

type Props = {
  isCheckDailyReportUse: boolean
  selectedWorkspaceIds: (number | undefined)[]
  onChange: (checked: boolean) => void
}

export const UseDailyReportCheckBox = ({ isCheckDailyReportUse, selectedWorkspaceIds, onChange }: Props) => {
  const { dailyReportsImportSettingsList } = useSelector(selectDailyReportsStatus, shallowEqual)

  const dailyReportWorkspaceIds = useMemo(() => {
    return dailyReportsImportSettingsList.reduce((acc: number[], cur) => {
      if (cur.workspaceIds.length === 0) {
        return acc
      }

      return acc.concat(cur.workspaceIds)
    }, [])
  }, [dailyReportsImportSettingsList])

  const isIncludedDailyReportWorkspace = useCallback(
    (workspaceId: number | undefined) => {
      if (!workspaceId) {
        return false
      }
      return dailyReportWorkspaceIds.includes(workspaceId)
    },
    [dailyReportWorkspaceIds]
  )

  const isShow = useMemo(() => {
    return selectedWorkspaceIds.some(id => isIncludedDailyReportWorkspace(id))
  }, [isIncludedDailyReportWorkspace, selectedWorkspaceIds])

  return (
    <>
      {isShow ? (
        <div className="form-check">
          <Input
            className="form-check-input"
            id="daily-report"
            checked={isCheckDailyReportUse}
            type="checkbox"
            onChange={e => onChange(e.target.checked)}
          />
          <Label className="form-check-label mb-0" for="daily-report">
            日報実績を利用
          </Label>
        </div>
      ) : null}
    </>
  )
}
